import { Pipe, PipeTransform } from '@angular/core';
import { ProcessingStatus } from '../enums/lead/processing-status.enum';
import { LeadHead } from '../models/lead/lead-head.model';

@Pipe({
    name: 'isLeadRejectable',
    standalone: false
})
export class IsLeadRejectablePipe implements PipeTransform {

  transform(value: LeadHead | undefined | null): boolean {
    if (!value) return false
    return value.processingStatus == ProcessingStatus.WaitingReview
  }

}
